import { Component, OnInit , Output ,Input, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { NgWizardService } from 'ng-wizard';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';


@Component({
  selector: 'app-target-setup',
  templateUrl: './target-setup.component.html',
  styleUrls: ['./target-setup.component.scss']
})
export class TargetSetupComponent implements OnInit {

  @Output() target : EventEmitter<boolean> = new EventEmitter;
  @Input () cartonid = "";
  targetUserList : any = [];
  page = 1;
  getPaginationCount;
  excelFormat: any = {};
  excelArray: any = [];
  excelData: any = [];
  cartonLocalFlags:any = {}

  constructor(
    private ngWizardService: NgWizardService,
    private router: Router,
    private exportExcelService: ExportExcelService,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration

  ) {
  }

  ngOnInit() {
    this.cartonLocalFlags = JSON.parse(localStorage.getItem('cartonFlgs'))

    this.getTarget();
    console.log(this.cartonid)
  }

  uploadExcel(id){
      this.router.navigate(["/hubAdmin/carton-upload/"+id + "/"+ 3+ "/" +this.cartonid])
  }
  getTarget(){
    this.apiService.getHeaders(this.apiConfig.CartonTargetList + `?campaign_id=${this.cartonid}&page=${this.page}`).subscribe((res : any)=>{
      console.log(res)
      this.targetUserList = res.body.data.pagination_data;
      if(this.targetUserList.length == 0){
        this.target.emit(false)
      }else{
        this.cartonLocalFlags = { ...this.cartonLocalFlags, targetFlag : true}
        localStorage.setItem('cartonFlgs' , JSON.stringify(this.cartonLocalFlags))
        }
      this.getPaginationCount = res.headers.get('X-Pagination-Total-Count')

      //2) for excelData
      this.excelData = res.body.data.excel_download_data;
      for (var k in this.excelData[0]) {
        if (typeof this.excelData[k] !== 'function') {
          console.log("Key is " + k.replace(/_/g, ' '));
          this.excelFormat.header = k.replace(/_/g, ' ');
          this.excelFormat.key = k
          this.excelArray.push(JSON.parse(JSON.stringify(this.excelFormat)));
          console.log(this.excelArray)
        }
      }
    })
  }
  DownloadReportExcel() {
    console.log("here")
    this.exportExcelService.DownloadReportExcel('Target_setup', this.excelData, this.excelArray);
  }

  paginationClick(e) {
    console.log(e);
    this.page = e;
    this.getTarget();
  }
}
